// extracted by mini-css-extract-plugin
export default {"containerStyle":"Input_containerStyle__qcVzl","inputStyle":"Input_inputStyle__ZCjJE","animatedTextStyle":"Input_animatedTextStyle__yxqBT"};